import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { FormController, Text, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';

import { SpecialtiesText } from '../../../../../../shared/specialties/SpecialtiesText';
import { receptionServiceTranslationKeys } from '../../../../../../translations';
import { ReceptionServiceFormController } from '../../../ReceptionServiceForm';
import { ReceptionServicePractitionerValue } from '../receptionServicePractitioner.types';

type ReceptionServicePractitionerTextViewProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly defaultValue: ReceptionServicePractitionerValue;
};

export const ReceptionServicePractitionerTextView = (props: ReceptionServicePractitionerTextViewProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <>
         <FormController<ReceptionServicePractitionerValue>
            controller={props.register('practitioner', validationRules)}
            defaultValue={props.defaultValue}
         >
            {({ value: { displayName, specialties } }) => (
               <TextView
                  testId={'practitioner'}
                  label={receptionServiceTranslationKeys.shared.form.components.practitionerTextView.label}
               >
                  <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
                     <Text testId={'displayName'}>{displayName}</Text>
                     <SpecialtiesText specialties={specialties} />
                  </TextSeparator>
               </TextView>
            )}
         </FormController>
      </>
   );
};
